module.exports = __webpack_public_path__ + "static/media/play.b8a7e583.png";